import CustomBreadcrumbs from 'src/legacy/components/custom-breadcrumbs';
import { useLocales } from 'src/legacy/locales';
import { PATH_DASHBOARD } from 'src/legacy/routes/paths';

import {
  defaultTabs,
  useUserDetailsNavigatorContext,
} from './UserDetailsNavigatorContext';

type Props = {
  displayName: string;
};

export const Breadcrumbs = ({ displayName }: Props) => {
  const { currentTab } = useUserDetailsNavigatorContext();
  const { translate } = useLocales();

  const pageName =
    defaultTabs.find(({ value }) => value === currentTab)?.label || 'profile';

  return (
    <CustomBreadcrumbs
      heading={displayName}
      links={[
        { href: PATH_DASHBOARD.root, name: `${translate('dashboard')}` },
        { href: PATH_DASHBOARD.user.root, name: `${translate('users')}` },
        { name: `${translate(pageName)}` },
      ]}
    />
  );
};
